import React from "react";

/**
 * Progress bar with rocket. The rocket uses `translateX` so it animates on the
 * GPU, while the fill uses `width` with a cubic-bezier transition.
 */
export function ProgressBar({ value, total }) {
    const pct = Math.max(0, Math.min(100, (value / total) * 100));
    return (
        <div
            className="relative w-full"
            role="progressbar"
            aria-valuenow={value}
            aria-valuemin={0}
            aria-valuemax={total}
            aria-label={`Question ${value} of ${total}`}
            data-testid="survey-progress-bar"
        >
            <div className="h-[6px] w-full rounded-full bg-klareet-BOR/50 overflow-hidden">
                <div
                    className="h-full bg-gradient-to-r from-klareet-T to-klareet-T2 rounded-full transition-[width] duration-500 ease-[cubic-bezier(.4,0,.2,1)]"
                    style={{ width: `${pct}%` }}
                />
            </div>
            <div
                className="absolute -top-4 text-lg transition-transform duration-500 ease-[cubic-bezier(.4,0,.2,1)] will-change-transform"
                style={{ transform: `translateX(calc(${pct}% - 12px))` }}
                aria-hidden
            >
                🚀
            </div>
            <div className="mt-4 flex items-center justify-between text-[11px] uppercase tracking-[0.14em] text-klareet-MUT font-mono">
                <span>Step {value}</span>
                <span>of {total}</span>
            </div>
        </div>
    );
}
